// 맞춤 개발 문의 — 진입 화면. SOFTCAT 디자인 시스템 이식본.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import CustomProductSecondPage from './CustomProductSecondPage';

const STEPS = [
    ["STEP 01", "요구사항 상담", "문의 폼·카카오톡으로 필요한 업무를 알려주세요. 영업일 1~2일 내 회신드려요."],
    ["STEP 02", "견적·일정 확정", "기능 명세서를 함께 정리하고 견적과 일정을 확정합니다."],
    ["STEP 03", "개발·중간 시연", "중간 시연으로 방향을 맞추며 개발합니다."],
    ["STEP 04", "납품·A/S", "설치 가이드·매뉴얼과 함께 납품하고 이후를 지원합니다."],
];

const CustomProductPage1 = () => {
    const navigate = useNavigate();

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // 클릭 한 번을 없앤다. 폼이 같은 페이지 아래에 있으므로 스크롤만 한다.
    const goForm = () => {
        const el = document.getElementById('inquiry-form');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        else navigate('/custom-product-second');
    };

    return (
        <>
            <div className="sch-ph">
                <div className="sch-wrap">
                    <div className="sch-no">CONTACT — 맞춤 개발</div>
                    <h1>당신의 원활한 작업을 위한<br />맞춤형 소프트웨어 솔루션</h1>
                    <p>
                        업무에 딱 맞는 자동화 도구를 요구사항 명세부터 납품·교육까지 책임지고
                        개발합니다. 견적 상담은 무료입니다.
                    </p>
                </div>
            </div>

            <section className="sch-sec">
                <div className="sch-wrap sch-sec__grid">
                    <div className="sch-sec__label">
                        <div className="sch-no">(01)</div>
                        <h2>진행 방식</h2>
                        <p>신청서를 남겨주시면 영업일 1~2일 내로 연락드립니다.</p>
                    </div>
                    <div className="sch-steps">
                        {STEPS.map(([n, title, desc]) => (
                            <div className="sch-s" key={n}>
                                <div className="sch-n">{n}</div>
                                <h3>{title}</h3>
                                <p>{desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="sch-ctax">
                <div className="sch-wrap">
                    <h2>만들고 싶은<br /><em>자동화</em>가 있나요?</h2>
                    <button
                        className="sch-bigbtn"
                        style={{ background: "#fff", color: "var(--primary-dark)" }}
                        onClick={goForm}
                    >
                        무료 견적 받기
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                             strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M5 12h14M13 6l6 6-6 6" />
                        </svg>
                    </button>
                </div>
            </section>

            <div id="inquiry-form">
                <CustomProductSecondPage embedded />
            </div>
        </>
    );
};

export default CustomProductPage1;
